import React from 'react'

const SpaMaster = () => {
  return (
    <div>SpaMaster</div>
  )
}

export default SpaMaster